import { render, staticRenderFns } from "./ModalCreateAsset.vue?vue&type=template&id=53c64738"
import script from "./ModalCreateAsset.vue?vue&type=script&lang=js"
export * from "./ModalCreateAsset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports